module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-05-0558b49bd06de12346b5e429f6336f74.svg";